<template>
  <account-modal class="enable-account-modal">
    <template slot="heading">
      <template>Unblock account<template v-if="account.hasName">&nbsp;“{{ account.name }}”</template>?</template>
    </template>

    <template slot="content">
      <p class="mb-2">Please, confirm that you want to unblock account<template v-if="account.hasName">&nbsp;<b>“{{ account.name }}”</b></template>. Note that:</p>

      <ul class="pb-0">
        <li>anybody will be able to send money to this account;</li>
        <li>you and the client will be able to top up account or make transfers from it;</li>
        <li>if there are funds it will be unfrozen.</li>
      </ul>

      <v-alert
        v-if="hasBlockedMasterFeeAccount"
        class="error-alert"
        type="error"
        :value="true"
        dense
        :dismissible="false"
      >Warning: The master account you are unblocking has a linked fee account that remains blocked. To ensure smooth operation, please unblock the linked fee account or assign a new active fee account to this master account.</v-alert>
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading || hasBlockedMasterFeeAccount"
        @click="onUnblockButtonClick"
      >unblock</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'EnableAccountModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    data () {
      return {
        accountUblockApiRequest: new ApiRequest(AccountApi.unblock)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.userId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.accountUblockApiRequest.loading
      },
      error () {
        return this.accountUblockApiRequest.error
      },
      masterFeeAccount () {
        const { feeWalletId } = this.account

        return this.modal.data.accounts.find(({ accountId }) => accountId === feeWalletId) ?? null
      },
      hasBlockedMasterFeeAccount () {
        return this.masterFeeAccount && this.masterFeeAccount.isBlocked
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onUnblockButtonClick () {
        this.accountUblockApiRequest
          .execute(this.account.accountId)
          .then(this.accountUblockSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountUblockSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been successfully unblocked.' }
          })
        }, 100)
      }
    }
  }
</script>
